import { Injectable } from "@angular/core";
import { CrudAction } from "../../helpers/enums";
import { Observable } from "rxjs/internal/Observable";
import { Subject } from "rxjs/internal/Subject";

@Injectable({
  providedIn: "root"
})
export class CrudService {
  private _crudStateSource = new Subject<number>();
  private _crud = 0;

  crudStateTracker: Observable<number> = this._crudStateSource.asObservable();

  get CRUD(): number {
    return this._crud;
  }

  readonly message = "No tiene privilegios para ejecutar esta acciÃ³n";

  notifyCRUD(state: number) {
    this._crud = state;
    this._crudStateSource.next(this._crud);
  }

  canExecute(crudAction: CrudAction): boolean {
    return (this.CRUD & crudAction) === crudAction;
  }
}
